/**
 * Csv Schema of CargaTransfolha
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaTransfolha} from '@/model/resource/CargaTransfolha'

/* TODO: review generated schema */
export class CsvCargaTransfolhaSchema extends Schema {
  readonly name = 'CsvCargaTransfolha'

  readonly fieldSet: FieldSet<CargaTransfolha> = {
    idCargaTransfolhaPk: schema => schema.model.idCargaTransfolhaPk,
    carga: schema => schema.model.carga?.$id ?? null,
    pedido: schema => schema.model.pedido,
    lote: schema => schema.model.lote,
    lastIdCodigo: schema => schema.model.lastIdCodigo,
    dateLastEvent: schema => schema.model.dateLastEvent,
    hourLastEvent: schema => schema.model.hourLastEvent,
    lastDateTry: schema => Helper.datetime(schema.model.lastDateTry),
  }
}
